
import AddIcon from '@material-ui/icons/Add';
import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import TextField from '@material-ui/core/TextField';
import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete';
import fire from '../../../config/firebase';
import "../../../assets/scss/autocomplete.scss";
import parse from 'autosuggest-highlight/parse';
import Moment from 'moment';
import matchRegex from 'autosuggest-highlight/match';
import ClickAwayListener from "@material-ui/core/ClickAwayListener";

const filter = createFilterOptions();

function AutoCompletePhase({ selectValue, show,
  title, dataList = [], update, phaseName = '',
  cla, classes,
}) {
  const type = 'phases';
  const [value, setValue] = useState(selectValue);

  const addNewItem = (name) => {
    update({ phaseName: name });
    Object.filter = (obj, predicate) =>
      Object.keys(obj)
        .filter(key => predicate(obj[key]))
        .reduce((res, key) => (res[key] = obj[key]), {});

    const listRef = fire.database().ref(type);
    const itemData = {
      title: name,
      date: Moment(new Date()).format('DD/MM/YYYY'),
      borderColor: "#fffff"
    };
    listRef.once('value', (snap) => {
      const db = snap.val();
      listRef.off('value');
      const filteredList = Object.filter(db, item => item.title === name);
      if (Object.keys(filteredList).length === 0) {
        listRef.push(itemData);
      }
    });
  }
  const [open, setOpen] = useState(false);
  return (
    <ClickAwayListener onClickAway={() => { setOpen(false); }}>
      <Autocomplete
        autoSelect
        open={open}
        onOpen={() => {
          setOpen(true);
        }}
        onClose={() => {
          setOpen(false);
        }}
        value={value}
        defaultValue={phaseName}
        className={cla + ' ' + classes}
        onChange={(event, newValue) => {
          if (newValue === null) { return }
          setValue(newValue);
          if (newValue && newValue.inputValue) {
            addNewItem(newValue.inputValue)
          } else {
            update({ phaseName: newValue.title });
          }
          if (show) {
            show();
          }
        }
        }
        filterOptions={(options, params) => {
          const filtered = filter(options, params);
          // Suggest the creation of a new value
          if (type === "resources" && params.inputValue !== '') {
            filtered.push({
              title: <span key={filtered.length} className={`add-button ${classes}`}>
                <AddIcon /> Add "{params.inputValue}" as a new {title}</span>,
              inputValue: params.inputValue,
            });

          }
          else if (params.inputValue !== '') {
            filtered.push({
              title: <span key={filtered.length} className={`add-button ${classes}`}>
                <AddIcon /> Add "{params.inputValue}" as a new {title}</span>,
              inputValue: params.inputValue,
            });
          }
          return filtered;
        }
        }
        selectOnFocus
        clearOnBlur
        blurOnSelect
        handleHomeEndKeys
        options={(dataList || []).filter(d => d.archive !== 'true')}
        getOptionLabel={(option) => {
          if (typeof option === 'string') {
            return option;
          }
          if (option.inputValue) {
            return option.inputValue;
          }
          return option.title;
        }}
        renderOption={(option, { inputValue }) => {
          const matches = matchRegex(option.title, inputValue);
          const parts = parse(option.title, matches);
          return (
            <div>
              {parts.map((part, index) => (
                <span key={index} style={{ fontWeight: part.highlight ? 700 : 400 }}>
                  {part.text}
                </span>
              ))}
            </div>
          );
        }}

        style={{ width: 300 }}
        freeSolo
        renderInput={(params) => (
          <TextField {...params} label={title} />
        )}
      />
    </ClickAwayListener>
  );
}
export default withRouter(AutoCompletePhase);